const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/reco/api/ai-compare"
    : "http://k8s-machinecraftmain-f16cc05195-1227403734.ap-northeast-3.elb.amazonaws.com/reco/api/ai-compare";
const API_KEY = "reco-api-550e8400e29b41d4a716446655440000";

export type CompareProduct = any;

/**
 * ai-compare SSE を開始する
 */
export async function startAiCompareStream(
  products: CompareProduct[],
  onChunk: (text: string) => void,
  onDone: () => void,
  onError: (e: unknown) => void
) {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream",
      "x-api-key": API_KEY,
    },
    body: JSON.stringify({
      product_ids: products.map(p => p.id),
      products: products,
    }),
  });

  if (!res.ok || !res.body) {
    throw new Error("ai-compare API request failed");
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder("utf-8");

  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();

    if (value) {
      buffer += decoder.decode(value, { stream: true });

      const lines = buffer.split("\n");
      buffer = lines.pop() ?? "";

      for (const line of lines) {
        if (!line.startsWith("data:")) continue;

        const data = line.replace(/^data:\s?/, "");

        if (data === "[DONE]") {
          onDone();
          return;
        }

        onChunk(data.replace(/\\n/g, "\n"));
      }
    }

    if (done) {
      // ★ 最後に残った buffer を処理
      if (buffer.startsWith("data:")) {
        const data = buffer.replace(/^data:\s?/, "");
        onChunk(data.replace(/\\n/g, "\n"));
      }

      onDone();
      return;
    }
  }
}

